import {
  SET_VIEW,
  SET_VIEW_MONTH,
  SET_VIEW_YEAR,
  SET_YEAR,
  TOGGLE_ALLOWANCE,
  TOGGLE_LEAVE,
  TOGGLE_VIEW,
  TOGGLE_APPROVE,
  TOGGLE_HISTORY,
  //
  ADD_LEAVE,
  ADD_LEAVE_SUCCESS,
  ADD_LEAVE_FAILURE,
  PREVIEW_ANNUAL_LEAVE,
  PREVIEW_ANNUAL_LEAVE_SUCCESS,
  PREVIEW_ANNUAL_LEAVE_FAILURE,
  //
  EDIT_LEAVE,
  EDIT_LEAVE_SUCCESS,
  EDIT_LEAVE_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  FETCH_LEAVE,
  FETCH_LEAVE_SUCCESS,
  FETCH_LEAVE_FAILURE,
  //
  SET_ALLOWANCE,
  SET_ALLOWANCE_SUCCESS,
  SET_ALLOWANCE_FAILURE,
  //
  DELETE_LEAVE,
  DELETE_LEAVE_SUCCESS,
  DELETE_LEAVE_FAILURE,
  //
  GET_YEARS,
  GET_YEARS_SUCCESS,
  GET_YEARS_FAILURE,
  //
  FETCH_HISTORY,
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAILURE,
  //
  FETCH_REQUESTS,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUESTS_FAILURE,
  FETCH_DIRECTOR_APPROVAL_COUNT,
  FETCH_DIRECTOR_APPROVAL_COUNT_SUCCESS,
  FETCH_DIRECTOR_APPROVAL_COUNT_FAILURE,
  //
  APRROVE_LEAVE,
  APRROVE_LEAVE_SUCCESS,
  APRROVE_LEAVE_FAILURE,
  //
  FETCH_MONTH,
  FETCH_MONTH_SUCCESS,
  FETCH_MONTH_FAILURE,
  //
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  //
  GET_HOME_LEAVES,
  GET_HOME_LEAVES_SUCCESS,
  GET_HOME_LEAVES_FAILURE,
  //
  UPDATE_LEAVE_EMP,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  TOGGLE_FILE_DEL,
  //
  FETCH_REPORT_LIST,
  FETCH_REPORT_LIST_SUCCESS,
  FETCH_REPORT_LIST_FAILURE,
  //
  GET_ACCRUAL_LEAVE,
  GET_ACCRUAL_LEAVE_SUCCESS,
  GET_ACCRUAL_LEAVE_FAILURE,
  //
  GET_ACCRUAL_PERIOD,
  GET_ACCRUAL_PERIOD_SUCCESS,
  GET_ACCRUAL_PERIOD_FAILURE,
  //
  EXPORT_ACCRUAL,
  EXPORT_ACCRUAL_SUCCESS,
  EXPORT_ACCRUAL_FAILURE,
  EXPORT_LEAVE,
  EXPORT_LEAVE_SUCCESS,
  EXPORT_LEAVE_FAILURE,
  //
  GET_AVG_HOURS,
  GET_AVG_HOURS_SUCCESS,
  GET_AVG_HOURS_FAILURE,
} from "./constants";

// List
export const setView = (payload) => ({
  type: SET_VIEW,
  payload,
});
export const setViewMonth = (payload) => ({ type: SET_VIEW_MONTH, payload });
export const setViewYear = (payload) => ({ type: SET_VIEW_YEAR, payload });
export const setYear = (payload) => ({ type: SET_YEAR, payload });
export const toggleAllowance = (payload) => ({
  type: TOGGLE_ALLOWANCE,
  payload,
});
export const toggleLeave = (payload) => ({ type: TOGGLE_LEAVE, payload });
export const toggleApprove = (payload) => ({ type: TOGGLE_APPROVE, payload });
export const toggleView = (payload) => ({ type: TOGGLE_VIEW, payload });
export const toggleHistory = (payload) => ({ type: TOGGLE_HISTORY, payload });

//
export const addLeave = (payload, onAddSuccess) => ({
  type: ADD_LEAVE,
  payload,
  onAddSuccess,
});
export const addLeaveSuccess = (payload) => ({
  type: ADD_LEAVE_SUCCESS,
  payload,
});
export const addLeaveFailure = (payload) => ({
  type: ADD_LEAVE_FAILURE,
  payload,
});
export const previewAnnualLeave = (payload, onSuccess, onFailure) => ({
  type: PREVIEW_ANNUAL_LEAVE,
  payload,
  onSuccess,
  onFailure,
});
export const previewAnnualLeaveSuccess = (payload) => ({
  type: PREVIEW_ANNUAL_LEAVE_SUCCESS,
  payload,
});
export const previewAnnualLeaveFailure = (payload) => ({
  type: PREVIEW_ANNUAL_LEAVE_FAILURE,
  payload,
});

//
export const editLeave = (payload, onEditSuccess) => ({
  type: EDIT_LEAVE,
  payload,
  onEditSuccess,
});
export const editLeaveSuccess = (payload) => ({
  type: EDIT_LEAVE_SUCCESS,
  payload,
});
export const editLeaveFailure = (payload) => ({
  type: EDIT_LEAVE_FAILURE,
  payload,
});

// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});

// View
export const fetchLeave = (payload) => ({
  type: FETCH_LEAVE,
  payload,
});
export const fetchLeaveSuccess = (payload) => ({
  type: FETCH_LEAVE_SUCCESS,
  payload,
});
export const fetchLeaveFailure = (payload) => ({
  type: FETCH_LEAVE_FAILURE,
  payload,
});

// View
export const setAllowance = (payload, onSet) => ({
  type: SET_ALLOWANCE,
  payload,
  onSet,
});
export const setAllowanceSuccess = (payload) => ({
  type: SET_ALLOWANCE_SUCCESS,
  payload,
});
export const setAllowanceFailure = (payload) => ({
  type: SET_ALLOWANCE_FAILURE,
  payload,
});

// View
export const deleteLeave = (payload, onDelete) => ({
  type: DELETE_LEAVE,
  payload,
  onDelete,
});
export const deleteLeaveSuccess = (payload) => ({
  type: DELETE_LEAVE_SUCCESS,
  payload,
});
export const deleteLeaveFailure = (payload) => ({
  type: DELETE_LEAVE_FAILURE,
  payload,
});

//
export const getYears = (payload, onYearSuccess) => ({
  type: GET_YEARS,
  payload,
  onYearSuccess,
});
export const getYearsSuccess = (payload) => ({
  type: GET_YEARS_SUCCESS,
  payload,
});
export const getYearsFailure = (payload) => ({
  type: GET_YEARS_FAILURE,
  payload,
});

//
export const fetchHistory = (payload) => ({
  type: FETCH_HISTORY,
  payload,
});
export const fetchHistorySuccess = (payload) => ({
  type: FETCH_HISTORY_SUCCESS,
  payload,
});
export const fetchHistoryFailure = (payload) => ({
  type: FETCH_HISTORY_FAILURE,
  payload,
});

//
export const fetchRequests = (payload) => ({
  type: FETCH_REQUESTS,
  payload,
});
export const fetchRequestsSuccess = (payload) => ({
  type: FETCH_REQUESTS_SUCCESS,
  payload,
});
export const fetchRequestsFailure = (payload) => ({
  type: FETCH_REQUESTS_FAILURE,
  payload,
});

// Pending leave that needs a director's approval, for the count on the
// "Requires Director Approval" toggle. Same filters as fetchRequests.
export const fetchDirectorApprovalCount = (payload) => ({
  type: FETCH_DIRECTOR_APPROVAL_COUNT,
  payload,
});
export const fetchDirectorApprovalCountSuccess = (payload) => ({
  type: FETCH_DIRECTOR_APPROVAL_COUNT_SUCCESS,
  payload,
});
export const fetchDirectorApprovalCountFailure = () => ({
  type: FETCH_DIRECTOR_APPROVAL_COUNT_FAILURE,
});

//
export const aprroveLeave = (payload, onSuccess) => ({
  type: APRROVE_LEAVE,
  payload,
  onSuccess,
});
export const aprroveLeaveSuccess = (payload) => ({
  type: APRROVE_LEAVE_SUCCESS,
  payload,
});
export const aprroveLeaveFailure = (payload) => ({
  type: APRROVE_LEAVE_FAILURE,
  payload,
});

//
export const fetchMonth = (payload, onSuccess) => ({
  type: FETCH_MONTH,
  payload,
  onSuccess,
});
export const fetchMonthSuccess = (payload) => ({
  type: FETCH_MONTH_SUCCESS,
  payload,
});
export const fetchMonthFailure = (payload) => ({
  type: FETCH_MONTH_FAILURE,
  payload,
});

//
export const getHistory = (payload) => ({
  type: GET_HISTORY,
  payload,
});
export const getHistorySuccess = (payload) => ({
  type: GET_HISTORY_SUCCESS,
  payload,
});
export const getHistoryFailure = (payload) => ({
  type: GET_HISTORY_FAILURE,
  payload,
});

//
export const getHomeLeaves = (payload, onSuccess) => ({
  type: GET_HOME_LEAVES,
  payload,
  onSuccess,
});
export const getHomeLeavesSuccess = (payload) => ({
  type: GET_HOME_LEAVES_SUCCESS,
  payload,
});
export const getHomeLeavesFailure = (payload) => ({
  type: GET_HOME_LEAVES_FAILURE,
  payload,
});

export const updateLeaveEmp = (payload) => ({
  type: UPDATE_LEAVE_EMP,
  payload,
});

//
export const deleteFile = (payload, onDel) => ({
  type: DELETE_FILE,
  payload,
  onDel,
});
export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});
export const deleteFileFailure = (payload) => ({
  type: DELETE_FILE_FAILURE,
  payload,
});
export const toggleFileDel = (payload) => ({
  type: TOGGLE_FILE_DEL,
  payload,
});

export const fetchReportList = (payload) => ({
  type: FETCH_REPORT_LIST,
  payload,
});
export const fetchReportListSuccess = (payload) => ({
  type: FETCH_REPORT_LIST_SUCCESS,
  payload,
});
export const fetchReportListFailure = (payload) => ({
  type: FETCH_REPORT_LIST_FAILURE,
  payload,
});

export const getAccrualLeave = (payload, onSuccess) => ({
  type: GET_ACCRUAL_LEAVE,
  payload,
  onSuccess,
});
export const getAccrualLeaveSuccess = (payload) => ({
  type: GET_ACCRUAL_LEAVE_SUCCESS,
  payload,
});
export const getAccrualLeaveFailure = (payload) => ({
  type: GET_ACCRUAL_LEAVE_FAILURE,
  payload,
});

export const getAccrualPeriod = (payload) => ({
  type: GET_ACCRUAL_PERIOD,
  payload,
});
export const getAccrualPeriodSuccess = (payload) => ({
  type: GET_ACCRUAL_PERIOD_SUCCESS,
  payload,
});
export const getAccrualPeriodFailure = (payload) => ({
  type: GET_ACCRUAL_PERIOD_FAILURE,
  payload,
});

export const exportAccrual = (payload) => ({
  type: EXPORT_ACCRUAL,
  payload,
});
export const exportAccrualSuccess = (payload) => ({
  type: EXPORT_ACCRUAL_SUCCESS,
  payload,
});
export const exportAccrualFailure = (payload) => ({
  type: EXPORT_ACCRUAL_FAILURE,
  payload,
});

export const exportLeave = (payload) => ({
  type: EXPORT_LEAVE,
  payload,
});
export const exportLeaveSuccess = (payload) => ({
  type: EXPORT_LEAVE_SUCCESS,
  payload,
});
export const exportLeaveFailure = (payload) => ({
  type: EXPORT_LEAVE_FAILURE,
  payload,
});

export const getAvgHours = (payload, onSuccess) => ({
  type: GET_AVG_HOURS,
  payload,
  onSuccess,
});
export const getAvgHoursSuccess = (payload) => ({
  type: GET_AVG_HOURS_SUCCESS,
  payload,
});
export const getAvgHoursFailure = (payload) => ({
  type: GET_AVG_HOURS_FAILURE,
  payload,
});
